export default "__VITE_ASSET__sHMXZiZc__"